import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/system";
import { getpageDetail } from "../../redux/action-creators/profileAction";
import { formatCmsHtml } from "../../utils/helper";
import { UserCommonStyles } from "../../styles/CommonStyles";
import { HeaderStyles } from "../../styles/Header";
import Logo from "../../images/logo-petlover.png";

export const TERMS_PAGE_ID = 2;
export const PRIVACY_PAGE_ID = 3;

const LegalCmsPage = ({
  pageId,
  failedKey,
  extra,
}: {
  pageId: number;
  failedKey: string;
  extra?: React.ReactNode;
}) => {
  const dispatch = useDispatch();
  const { t: translation } = useTranslation();
  const commonStyle = UserCommonStyles();
  const styleClasses = HeaderStyles();
  const [loader, setLoader] = useState(true);
  const [pageDetail, setPageDetail] = useState<{ title?: string; content?: string } | null>(null);

  const loadPage = useCallback(async () => {
    const result: any = await dispatch(getpageDetail(pageId));
    if (result) setPageDetail(result);
    setLoader(false);
  }, [dispatch, pageId]);

  useEffect(() => {
    void loadPage();
  }, [loadPage]);

  return (
    <div className={commonStyle.p20} style={{ maxWidth: 880, lineHeight: 1.65, letterSpacing: "normal" }}>
      <Box className={`${commonStyle.mb20} ${styleClasses.logo}`}>
        <Link to="/">
          <img src={Logo} alt="logo" />
        </Link>
      </Box>
      {pageDetail?.content ? (
        <>
          {pageDetail.title ? <h3>{pageDetail.title}</h3> : null}
          <div
            className="cms-page-content"
            dangerouslySetInnerHTML={{ __html: formatCmsHtml(pageDetail.content) }}
          />
          {extra}
        </>
      ) : (
        <p>{loader ? translation("loading") : translation(failedKey)}</p>
      )}
    </div>
  );
};

export default LegalCmsPage;
